import React from "react";
import CopyRight from "./CopyRight/CopyRight";
import { Container, Row, Col } from "react-bootstrap";
import facebookIcon from "./CopyRight/icons/facebook.png";
import "./Footer.css";
const Footer = () => {
  return (
    <>
      <CopyRight />
    </>
  );
};

export default Footer;
